let count: number | null = null;
const listeners = new Set<() => void>();

export function publishCartCount(nextCount: number): void {
  if (!Number.isInteger(nextCount) || nextCount < 0 || nextCount === count)
    return;
  count = nextCount;
  listeners.forEach((listener) => listener());
}

export function getCartCountSnapshot(): number | null {
  return count;
}

// Request-specific counts stay in props, never in the shared SSR module.
export function getServerCartCountSnapshot(): null {
  return null;
}

export function subscribeCartCount(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
